import React from 'react';
import { Page } from '../Page';
import { AppLoader } from './elements';
import './styles.scss';

export interface IAppProps {
  isAppLoaded: boolean;
}

export class App extends React.Component<IAppProps> {
  render() {
    if (!this.props.isAppLoaded) {
      return <AppLoader />;
    }

    return <Page />;
  }
}
